export class RegisterAccountCredentials {
  public AccountId?: string;
  public Username?: string;
  public Password?: string;
  public EmailId?: string;
  public CustomerClass?: string;
}
